import { formatMoney } from "Helpers/helpFunction";

export const options = (data: any, CommnonStore: any, FilterLabel: string) => {
  let fontSize = '14px';
  let windownWidth = 473;
  if (CommnonStore?.innerWidthScreen < 700) {
    windownWidth = 300;
    fontSize = '10px'
  }

  const series = [];
  if (FilterLabel.length === 0 || FilterLabel.indexOf('Doanh thu thuần') > -1) {
    series.push({
      name: 'Doanh thu thuần',
      data: data?.netsale,
      color: '#22AB24',
      borderWidth: 0,
      type: 'column',
      yAxis: 0,
    })
  }
  if (FilterLabel.length === 0 || FilterLabel.indexOf('Lợi nhuận gộp') > -1) {
    series.push({
      name: 'Lợi nhuận gộp',
      data: data?.gross_profit,
      color: '#B8B8B8',
      borderWidth: 0,
      type: 'column',
      yAxis: 0,
    })
  }
  if (FilterLabel.length === 0 || FilterLabel.indexOf('Lợi nhuận sau thuế') > -1) {
    series.push({
      name: 'Lợi nhuận sau thuế',
      data: data?.net_profit,
      color: '#F7931A',
      borderWidth: 0,
      type: 'column',
      yAxis: 0,
    });
  }
  if (FilterLabel.length === 0 || FilterLabel.indexOf('Tăng trưởng DTT') > -1) {
    series.push({
      name: 'Tăng trưởng DTT',
      type: 'line',
      yAxis: 1,
      data: data?.net_sale_growth,
      color: '#E31E4D',
      lineWidth: 1.2,
      marker: {
        lineColor: '#E31E4D',
        lineWidth: 0,
        fillColor: '#ffffff'
      },
      pointPlacement: -0.2,
    });
  }

  let tickIntervalNumber: any = ''
  if (CommnonStore?.innerWidthScreen > 1440) {
    tickIntervalNumber = null
  } else if (CommnonStore?.innerWidthScreen > 1200) {
    tickIntervalNumber = 2
  } else if (CommnonStore?.innerWidthScreen > 700) {
    tickIntervalNumber = 2
  } else if (CommnonStore?.innerWidthScreen > 0) {
    tickIntervalNumber = 2
  }
  return {
    chart: {
      backgroundColor: 'transparent',
      zoomType: 'xy',
      height: windownWidth
    },
    title: {
      text: ''
    },
    xAxis: {
      tickInterval: tickIntervalNumber,
      categories: data?.category,
      labels: {
        enabled: true,
        style: {
          color: '#ffffff',
          fontSize: fontSize,
        },
      },
      title: {
        text: ''
      },
      minorTickLength: 0,
      tickLength: 0,
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      lineWidth: 0,
    },
    yAxis: [{
      // tickInterval: 5000,
      minorTickLength: 0,
      tickLength: 0,
      gridLineWidth: 0,
      gridLineColor: '#4D4D4D',
      minorGridLineWidth: 0,
      lineWidth: 0,
      title: {
        enabled: CommnonStore?.innerWidthScreen > 700,
        text: 'Tỷ VNĐ',
        style: {
          color: '#B8B8B8',
          fontSize: fontSize
        }
      },
      labels: {
        style: {
          color: '#ffffff',
          fontSize: fontSize,
        },
        formatter: function (item: any) {
          return `${formatMoney((parseInt(item.value) / 1000000000).toFixed(0))}`
        }
      }
    }, {
      gridLineWidth: 0,
      opposite: true,
      title: {
        text: '',
        style: {
          color: '#ffffff'
        }
      },
      labels: {
        enabled: true,
        style: {
          color: '#ffffff',
          fontSize: fontSize,
        },
        formatter: function (item: any) {
          return `${formatMoney(item?.value)}%`;
        }
      }
    }],
    legend: {
      enabled: false,
      itemStyle: {
        color: '#ffffff'
      }
    },
    plotOptions: {
    },
    tooltip: {
      enabled: true,
      useHTML: true,
      borderRadius: 0,
      borderWidth: 0,
      backgroundColor: '#131313',
      formatter: function (item: any) {
        const conditition = 1000000000
        const thisData: any = this
        const index: any = thisData.point.index
        const netsale = data?.netsale?.[index] ? data?.netsale?.[index] / conditition : 0
        const net_profit = data?.net_profit?.[index] ? data?.net_profit?.[index] / conditition : 0
        const gross_profit = data?.gross_profit?.[index] ? data?.gross_profit?.[index] / conditition : 0
        const net_sale_growth = data?.net_sale_growth?.[index] ? data?.net_sale_growth?.[index] : 0
        const name = thisData.series.name
        const dv = CommnonStore?.innerWidthScreen > 700 ? `` : 'Tỷ VNĐ'

        return `<div class="ioalomryco">
        <div class="fzlgnzcgwl whlqpruvka">${thisData.point.category}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt ${name == 'Doanh thu thuần' ? 'tuazmvzmhb' : ''}">Doanh thu thuần: <span>${formatMoney(netsale.toFixed(2), 2)}</span> ${dv}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt ${name == 'Lợi nhuận gộp' ? 'tuazmvzmhb' : ''}">Lợi nhuận gộp: <span>${formatMoney(gross_profit.toFixed(2), 2)}</span> ${dv}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt ${name == 'Lợi nhuận sau thuế' ? 'tuazmvzmhb' : ''}">Lợi nhuận sau thuế: <span>${formatMoney(net_profit.toFixed(2), 2)}</span> ${dv}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt ${name == 'Tăng trưởng DTT' ? 'tuazmvzmhb' : ''}">Tăng trưởng DTT: <span style="color: ${net_sale_growth > 0 ? '#2AD03D' : '#E31E4D'}">${formatMoney(net_sale_growth.toFixed(2))}%</span></div>
        </div>`;
      }
    },
    series: series
  }
}